import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type AuthenticatedProvider = 'unknown' | 'cognito' | 'ehr'

const authenticatedProviderSlice = createSlice({
  name: 'authenticatedProvider',
  initialState: 'unknown' as AuthenticatedProvider,
  reducers: {
    establishAuthenticatedProvider: (_state, { payload }: PayloadAction<'cognito' | 'ehr'>) =>
      payload,
    resetAuthenticatedProvider: () => 'unknown' as AuthenticatedProvider,
  },
})

export const { establishAuthenticatedProvider, resetAuthenticatedProvider } =
  authenticatedProviderSlice.actions

export default authenticatedProviderSlice.reducer
